// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
=============== 
Reviews
===============
*/

main.reviews {
    min-height: 100vh;
    display: grid;
    place-items: center;
}

.title {
    text-align: center;
    margin-bottom: 4rem;
}

.underline {
    height: 0.25rem;
    width: 5rem;
    background: var(--clr-primary-5);
    margin-left: auto;
    margin-right: auto;
}

.reviews.container {
    width: 80vw;
    max-width: var(--fixed-width);
}

.review {
    background: var(--clr-white);
    padding: 1.5rem 2rem;
    border-radius: var(--radius);
    box-shadow: var(--light-shadow);
    transition: var(--transition);
    text-align: center;
}

.review:hover {
    box-shadow: var(--dark-shadow);
}

.img-container {
    position: relative;
    width: 150px;
    height: 150px;
    border-radius: 50%;
    margin: 0 auto;
    margin-bottom: 1.5rem;
}

.person-img.reviews {
    width: 100%;
    display: block;
    height: 100%;
    object-fit: cover;
    border-radius: 50%;
    position: relative;
}

.quote-icon {
    position: absolute;
    top: 0;
    left: 0;
    width: 2.5rem;
    height: 2.5rem;
    display: grid;
    place-items: center;
    border-radius: 50%;
    transform: translateY(25%);
    background: var(--clr-primary-5);
    color: var(--clr-white);
}

.img-container::before {
    content: '';
    width: 100%;
    height: 100%;
    background: var(--clr-primary-5);
    position: absolute;
    top: -0.25rem;
    right: -0.5rem;
    border-radius: 50%;
}

.author {
    margin-bottom: 0.25rem;
}

.job {
    margin-bottom: 0.5rem;
    text-transform: uppercase;
    color: var(--clr-primary-5);
    font-size: 0.85rem;
}

.info {
    margin-bottom: 0.75rem;
}

.prev-btn,
.next-btn {
    color: var(--clr-primary-7);
    font-size: 1.25rem;
    background: transparent;
    border-color: transparent;
    margin: 0 0.5rem;
    transition: var(--transition);
    cursor: pointer;
}

.prev-btn:hover,
.next-btn:hover {
    color: var(--clr-primary-5);
}

.random-btn {
    margin-top: 0.5rem;
    background: var(--clr-primary-10);
    color: var(--clr-primary-5);
    padding: 0.25rem 0.5rem;
    text-transform: capitalize;
    border-radius: var(--radius);
    transition: var(--transition);
    border-color: transparent;
    cursor: pointer;
}

.random-btn:hover {
    background: var(--clr-primary-5);
    color: var(--clr-primary-1);
}`, "",{"version":3,"sources":["webpack://./src/reviews/reviews.css"],"names":[],"mappings":"AAAA;;;;CAIC;;AAED;IACI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,gCAAgC;IAChC,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,6BAA6B;AACjC;;AAEA;IACI,4BAA4B;IAC5B,oBAAoB;IACpB,4BAA4B;IAC5B,+BAA+B;IAC/B,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,aAAa;IACb,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,0BAA0B;IAC1B,gCAAgC;IAChC,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,gCAAgC;IAChC,kBAAkB;IAClB,aAAa;IACb,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,2BAA2B;IAC3B,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;;IAEI,2BAA2B;IAC3B,kBAAkB;IAClB,uBAAuB;IACvB,yBAAyB;IACzB,gBAAgB;IAChB,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;;IAEI,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,iCAAiC;IACjC,2BAA2B;IAC3B,uBAAuB;IACvB,0BAA0B;IAC1B,4BAA4B;IAC5B,6BAA6B;IAC7B,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,gCAAgC;IAChC,2BAA2B;AAC/B","sourcesContent":["/*\r\n=============== \r\nReviews\r\n===============\r\n*/\r\n\r\nmain.reviews {\r\n    min-height: 100vh;\r\n    display: grid;\r\n    place-items: center;\r\n}\r\n\r\n.title {\r\n    text-align: center;\r\n    margin-bottom: 4rem;\r\n}\r\n\r\n.underline {\r\n    height: 0.25rem;\r\n    width: 5rem;\r\n    background: var(--clr-primary-5);\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n}\r\n\r\n.reviews.container {\r\n    width: 80vw;\r\n    max-width: var(--fixed-width);\r\n}\r\n\r\n.review {\r\n    background: var(--clr-white);\r\n    padding: 1.5rem 2rem;\r\n    border-radius: var(--radius);\r\n    box-shadow: var(--light-shadow);\r\n    transition: var(--transition);\r\n    text-align: center;\r\n}\r\n\r\n.review:hover {\r\n    box-shadow: var(--dark-shadow);\r\n}\r\n\r\n.img-container {\r\n    position: relative;\r\n    width: 150px;\r\n    height: 150px;\r\n    border-radius: 50%;\r\n    margin: 0 auto;\r\n    margin-bottom: 1.5rem;\r\n}\r\n\r\n.person-img.reviews {\r\n    width: 100%;\r\n    display: block;\r\n    height: 100%;\r\n    object-fit: cover;\r\n    border-radius: 50%;\r\n    position: relative;\r\n}\r\n\r\n.quote-icon {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    width: 2.5rem;\r\n    height: 2.5rem;\r\n    display: grid;\r\n    place-items: center;\r\n    border-radius: 50%;\r\n    transform: translateY(25%);\r\n    background: var(--clr-primary-5);\r\n    color: var(--clr-white);\r\n}\r\n\r\n.img-container::before {\r\n    content: '';\r\n    width: 100%;\r\n    height: 100%;\r\n    background: var(--clr-primary-5);\r\n    position: absolute;\r\n    top: -0.25rem;\r\n    right: -0.5rem;\r\n    border-radius: 50%;\r\n}\r\n\r\n.author {\r\n    margin-bottom: 0.25rem;\r\n}\r\n\r\n.job {\r\n    margin-bottom: 0.5rem;\r\n    text-transform: uppercase;\r\n    color: var(--clr-primary-5);\r\n    font-size: 0.85rem;\r\n}\r\n\r\n.info {\r\n    margin-bottom: 0.75rem;\r\n}\r\n\r\n.prev-btn,\r\n.next-btn {\r\n    color: var(--clr-primary-7);\r\n    font-size: 1.25rem;\r\n    background: transparent;\r\n    border-color: transparent;\r\n    margin: 0 0.5rem;\r\n    transition: var(--transition);\r\n    cursor: pointer;\r\n}\r\n\r\n.prev-btn:hover,\r\n.next-btn:hover {\r\n    color: var(--clr-primary-5);\r\n}\r\n\r\n.random-btn {\r\n    margin-top: 0.5rem;\r\n    background: var(--clr-primary-10);\r\n    color: var(--clr-primary-5);\r\n    padding: 0.25rem 0.5rem;\r\n    text-transform: capitalize;\r\n    border-radius: var(--radius);\r\n    transition: var(--transition);\r\n    border-color: transparent;\r\n    cursor: pointer;\r\n}\r\n\r\n.random-btn:hover {\r\n    background: var(--clr-primary-5);\r\n    color: var(--clr-primary-1);\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
